import { render, staticRenderFns } from "./choose-organ.vue?vue&type=template&id=426aedf4&scoped=true"
import script from "./choose-organ.vue?vue&type=script&lang=js"
export * from "./choose-organ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426aedf4",
  null
  
)

export default component.exports